import { gridSizeMdLg12 } from "@/shared";
import { CustomTextAreaNoForm, CustomTextFieldNoForm } from "@/shared/components/ui";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { City, ISolicitudCanje, Province } from "@/shared/interfaces";
import { Grid } from "@mui/material";

interface IModalSolicitudCanje {
    showModal:boolean;
    setShowModal: React.Dispatch<React.SetStateAction<boolean>>
    dataSelected: ISolicitudCanje & {
        provincia_data?: Province
        ciudad_data?: City
    }
}

export default function ModalSolicitudCanje({
    showModal,
    setShowModal,
    dataSelected
}:IModalSolicitudCanje) {
  return (
    <>
        {showModal?
            <ScrollableDialogProps
                open={showModal}
                title="Información de Canje"
                contentNode={
                <Grid {...gridSizeMdLg12} container spacing={3}>
                    {/* <CustomTextFieldNoForm
                    disabled
                    size={gridSizeMdLg12}
                    label={"NÚMERO DE REGISTRO"}
                    value={dataSelected?.numero_referencia || ""}
                    /> */}
                    <CustomTextFieldNoForm
                    disabled
                    size={gridSizeMdLg12}
                    label={"NOMBRE CLIENTE"}
                    value={dataSelected?.razon_social || ""}
                    />
                    <CustomTextFieldNoForm
                    disabled
                    size={gridSizeMdLg12}
                    label={"RUC/CÉDULA"}
                    value={dataSelected?.identificacion || ""}
                    />
                    <CustomTextFieldNoForm
                    disabled
                    size={gridSizeMdLg12}
                    label={"SERVICIO A CONTRATAR"}
                    value={dataSelected?.servicio || ""}
                    />
                    <CustomTextFieldNoForm
                    disabled
                    size={gridSizeMdLg12}
                    label={"CAPACIDAD"}
                    value={dataSelected?.capacidad || ""}
                    />
                    <CustomTextFieldNoForm
                    disabled
                    size={gridSizeMdLg12}
                    label={"PROVINCIA"}
                    value={dataSelected?.provincia_data?.nombre || ""}
                    />
                    <CustomTextFieldNoForm
                    disabled
                    size={gridSizeMdLg12}
                    label={"CIUDAD"}
                    value={dataSelected?.ciudad_data?.nombre || ""}
                    />
                    <CustomTextFieldNoForm
                    disabled
                    size={gridSizeMdLg12}
                    label={"COORDENADAS"}
                    value={dataSelected?.coordenadas || ""}
                    />
                    <CustomTextFieldNoForm
                    disabled
                    size={gridSizeMdLg12}
                    label={"DIRECCIÓN"}
                    value={dataSelected?.direccion || ""}
                    />
                    <CustomTextFieldNoForm
                    disabled
                    size={gridSizeMdLg12}
                    label={"NOMBRE DE CONTACTO"}
                    value={dataSelected?.nombre_contacto || ""}
                    />
                    <CustomTextFieldNoForm
                    disabled
                    size={gridSizeMdLg12}
                    label={"NÚMERO DE CONTACTO"}
                    value={dataSelected?.numero_contacto || ""}
                    />
        
                    <CustomTextAreaNoForm
                    disabled
                    size={gridSizeMdLg12}
                    label={"OBSERVACIÓN CANJE"}
                    value={dataSelected?.observaciones?.observacion_canje || ""}
                    />
        
                    <CustomTextFieldNoForm
                    disabled
                    size={gridSizeMdLg12}
                    label='Requiere Inspección'
                    value={dataSelected?.requiere_inspeccion ? "Sí" : "No"}
                    />
        
                    <CustomTextFieldNoForm
                    disabled
                    size={gridSizeMdLg12}
                    label='Requiere Cotización'
                    value={dataSelected?.requiere_cotizacion ? "Sí" : "No"}
                    />

                    <CustomTextFieldNoForm
                    disabled
                    size={gridSizeMdLg12}
                    label='Requiere Fibra Oscura'
                    value={dataSelected?.requiere_fibra_oscura ? "Sí" : "No"}
                    />
        
        
                </Grid>
                }
                showConfirmBtn={false}
                // onConfirm={form.handleSubmit(async () => {
                //   await mutateAsyncProspectoCorp({
                //     id: dataSelected?.id_prospecto,
                //     data: {
                //       celular: dataSelected?.celular
                //     }
                //   });
                //   reset({ celular: '', id_prospecto: '' });
                //   setShowModal(false);
                // })}
                onClose={() => setShowModal(false)}
            />
            :null
        }
    </>
  )
}
